import React from 'react';

const NavSectionContext = React.createContext<{
  navSection: V3.Navigation.SideSection | undefined;
  selectedItem: V3.Navigation.Item | undefined;
}>({
  navSection: undefined,
  selectedItem: undefined,
});

export default NavSectionContext;
